import { useSelector } from 'react-redux'
import { RootState } from 'reducers/rootReducer'
import { TranslationKeys } from 'types/translationKeys'
import { reverseArray } from 'utils/reverseArray'

export interface ServicesProps {
  isAr: boolean
  t: (key: TranslationKeys) => string
}

export const useServices = (props: ServicesProps) => {
  const servicesData = useSelector((state: RootState) => state.about.services)

  const animations = ['lightSpeedInRight', 'lightSpeedInLeft']
  const animationsReversed = reverseArray(animations)

  return {
    ...props,
    servicesData,
    animations,
    animationsReversed,
  }
}
